import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { skipToken, useQuery } from '@tanstack/react-query'

import { AccountConfig, SavingsLiquidityData } from '@/config/chain/types'
import { SimplifiedQueryResult } from '@/domain/common/query'

export interface UseSavingsLiquidityChartDataParams {
  selectedAccountConfig: AccountConfig | undefined
}
export interface UseSavingsLiquidityChartDataResult {
  queryResult: SimplifiedQueryResult<SavingsLiquidityData>
  shouldDisplayChart: boolean
  immediateLiquidity?: NormalizedNumber
  systemAvailableLiquidity?: NormalizedNumber
}

export function useSavingsLiquidityChartData({
  selectedAccountConfig,
}: UseSavingsLiquidityChartDataParams): UseSavingsLiquidityChartDataResult {
  const liquidityResult = selectedAccountConfig?.liquidityChartQueryOptions?.()
  const skipQueryOptions = {
    queryKey: ['skip'],
    queryFn: skipToken,
  } as const

  const queryResult = useQuery(liquidityResult?.queryOptions ?? skipQueryOptions)
  const shouldDisplayChart = liquidityResult !== undefined

  return {
    queryResult,
    shouldDisplayChart,
  }
}
